import { onLenisScroll, getScrollY } from './lenis-scroll';

let headerNavContainer = document.querySelector('.frge-header-nav');
let headerMenuLi = [];
if (headerNavContainer) {
    headerNavContainer.setAttribute('data-lenis-prevent', '');
    headerMenuLi = headerNavContainer.querySelectorAll('.menu-item');
    initNavFade(headerNavContainer);
}

// Fondu haut/bas du menu quand il reste des éléments à faire défiler
function initNavFade(nav) {
    let ticking = false;

    function update() {
        ticking = false;
        const maxScroll = nav.scrollHeight - nav.clientHeight;
        nav.classList.toggle('has-more-above', nav.scrollTop > 1);
        nav.classList.toggle('has-more-below', maxScroll - nav.scrollTop > 1);
    }

    function requestUpdate() {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    }

    nav.addEventListener('scroll', requestUpdate, { passive: true });

    if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(requestUpdate);
        observer.observe(nav);
        nav.querySelectorAll('.frge-header-nav__menu, .sub-menu').forEach(function (list) {
            observer.observe(list);
        });
    } else {
        window.addEventListener('resize', requestUpdate);
    }

    update();
}


let history = [];
let subMenuHistory = [];
let menuTitleHistory = [];
const backButton = document.querySelector('#back-button');
const svg = '<svg stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg>'

const openSearchIcon = document.querySelector('.header__search__open-icon');
const searchModal = document.querySelector('.search-modal');
const closeSearchIcon = document.querySelector('.frge-header-search-form__close-icon');
const bodyFilter = document.querySelector('.body-brighntess-filter');

const NotFoundSearchOpenModal = document.querySelector('.not-found__open-search');

if (NotFoundSearchOpenModal) {
    NotFoundSearchOpenModal.addEventListener('click', function (event) {
        event.preventDefault();
        searchModal.classList.toggle('is-open');
        document.body.classList.toggle('no-scroll');
        bodyFilter.classList.toggle('is-active');
    });
}

if (openSearchIcon && searchModal) {
    openSearchIcon.addEventListener('click', function (event) {
        searchModal.classList.toggle('is-open');
        document.body.classList.toggle('no-scroll');
        if (bodyFilter) {
            bodyFilter.classList.toggle('is-active');
        }
    });
}

if (closeSearchIcon && searchModal) {
    closeSearchIcon.addEventListener('click', function (event) {
        searchModal.classList.toggle('is-open');
        document.body.classList.toggle('no-scroll');
        if (bodyFilter) {

            bodyFilter.classList.toggle('is-active');
        }
    });
}
headerMenuLi.forEach(function (item, index) {
    const span = item.querySelector('span');
    if (span === null) return;

    if (item.classList.contains('has-children')) {
        span.addEventListener('click', function (event) {
            item.querySelector('.sub-menu').classList.remove('hidden');
            item.querySelector('.sub-menu').classList.add('visible');
            let parentItem = item.parentNode;
            let firstLevelLi = parentItem.querySelectorAll(':scope > li');
            firstLevelLi = Array.from(firstLevelLi);
            firstLevelLi.push(item.querySelector("span"));

            firstLevelLi.forEach(function (li) {
                if (li !== item) {
                    li.classList.toggle('hidden');
                }
            });

            history.push({
                items: firstLevelLi,
            });

            subMenuHistory.push({
                item: item.querySelector('.sub-menu'),
            })

            menuTitleHistory.push(span.innerText);

            if (history.length == 1) {
                backButton.classList.toggle('hidden');
            }
            backButton.innerHTML = svg + menuTitleHistory[menuTitleHistory.length - 1];
        });
    }
});


backButton.addEventListener('click', function (event) {
    if (history.length === 0) return;

    history[history.length - 1]['items'].forEach(function (item) {
        if (item.classList.contains('hidden')) {
            item.classList.remove('hidden');
            subMenuHistory[subMenuHistory.length - 1]['item'].classList.remove('visible');
            subMenuHistory[subMenuHistory.length - 1]['item'].classList.add('hidden');
        }
    })

    history.pop();
    subMenuHistory.pop();
    menuTitleHistory.pop();

    if (history.length > 0) {
        backButton.innerHTML = svg + menuTitleHistory[menuTitleHistory.length - 1];
    }

    if (history.length === 0) {
        backButton.classList.toggle('hidden');
    }
})


//Toggle menu
const headerMenuContainer = document.querySelector('.header-menu-container');
const menuToggleButton = document.querySelector('.header__menu-icon');
const menuCloseButton = document.querySelector('.header-menu-container__close-btn');

function setMenuScrollLock(isOpen) {
    if (!headerMenuContainer) {
        return;
    }
    if (isOpen) {
        headerMenuContainer.setAttribute('data-lenis-prevent', '');
    } else {
        headerMenuContainer.removeAttribute('data-lenis-prevent');
    }
}

function toggleMenu() {

    menuToggleButton.addEventListener('click', function (event) {
        headerMenuContainer.classList.toggle('is-open');
        const isOpen = headerMenuContainer.classList.contains('is-open');
        document.body.classList.toggle('no-scroll', isOpen);
        setMenuScrollLock(isOpen);
    })

    menuCloseButton.addEventListener('click', function (event) {
        headerMenuContainer.classList.toggle('is-open');
        const isOpen = headerMenuContainer.classList.contains('is-open');
        document.body.classList.toggle('no-scroll', isOpen);
        setMenuScrollLock(isOpen);
    });

    if (window.innerWidth > 600) {
        // Ajout du gestionnaire d'évènements pour le document
        document.addEventListener('click', function (event) {
            // Vérifie si le menu est ouvert et si le clic s'est produit en dehors du menu
            if (headerMenuContainer.classList.contains('is-open') && !headerMenuContainer.contains(event.target) && !menuToggleButton.contains(event.target)) {
                headerMenuContainer.classList.remove('is-open');
                document.body.classList.remove('no-scroll');
                setMenuScrollLock(false);
            }
        });
    }


}

toggleMenu();

// Header top : bascule de l'état « pilule » au scroll.
// - Le calage vertical (padding du main) est désormais géré en CSS pur (var(--header-height)),
//   ce qui supprime le saut de mise en page après le premier paint (CLS).
// - Le basculement .scrolled n'anime QUE transform/opacity (voir _header.scss) => 0 layout shift.
// - Listener passif + requestAnimationFrame + hystérésis (anti-flicker au seuil), branché sur le bus Lenis.
const headerTop = document.querySelector('.header__top');

const HEADER_SCROLL_ENTER = 40;
const HEADER_SCROLL_EXIT = 20;
let isHeaderScrolled = false;
let headerTicking = false;

function updateHeaderState() {
    const y = getScrollY();
    if (!isHeaderScrolled && y > HEADER_SCROLL_ENTER) {
        isHeaderScrolled = true;
        headerTop.classList.add('scrolled');
    } else if (isHeaderScrolled && y < HEADER_SCROLL_EXIT) {
        isHeaderScrolled = false;
        headerTop.classList.remove('scrolled');
    }
    headerTicking = false;
}

function requestHeaderUpdate() {
    if (!headerTicking) {
        headerTicking = true;
        window.requestAnimationFrame(updateHeaderState);
    }
}

if (headerTop) {
    // M-4 : premier rendu sans transition (deep-link / refresh en milieu de page).
    // On fige les transitions, on applique l'état initial (éventuellement .scrolled),
    // puis on réactive au frame suivant pour que les bascules ultérieures s'animent normalement.
    headerTop.classList.add('no-header-transition');
    updateHeaderState();
    window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
            headerTop.classList.remove('no-header-transition');
        });
    });

    onLenisScroll(requestHeaderUpdate);
    window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
}

